import { cn } from '@/utils/cn'
import type { DealsTableSortKey, SortDirection } from './dealsTableSorting'

export function DealsTableSortableHeader({
  label,
  sortKey,
  activeKey,
  direction,
  align = 'left',
  onSort,
}: {
  label: string
  sortKey: DealsTableSortKey
  activeKey: DealsTableSortKey
  direction: SortDirection
  align?: 'left' | 'center' | 'right'
  onSort: (key: DealsTableSortKey) => void
}) {
  const isActive = activeKey === sortKey
  const alignClass = align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : 'text-left'
  const sortState = isActive ? (direction === 'asc' ? 'ascending' : 'descending') : 'none'

  return (
    <th
      scope="col"
      aria-sort={sortState}
      className={`px-4 py-3 text-text-label font-medium uppercase tracking-wider text-xs ${alignClass}`}
    >
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className={cn(
          'inline-flex items-center gap-1 hover:text-text-primary transition-colors',
          align === 'right' && 'justify-end',
          align === 'center' && 'justify-center',
        )}
      >
        {label}
        <span className={cn('text-[10px]', isActive ? 'opacity-100' : 'opacity-30')} aria-hidden>
          {isActive && direction === 'desc' ? '↓' : '↑'}
        </span>
      </button>
    </th>
  )
}
